import MicrosoftLogin from "../components/Auth/microsoft-login";
import BrandedLogo from "../components/branded-logo";

const Auth = () => {
  return (
    <div className="w-[100%] h-[100vh] bg-background flex flex-col lg:flex-row items-center justify-between overflow-y-auto overflow-x-hidden">
      {/* AUTH PAGE LOGO */}
      <div className="w-[100%] lg:w-[45%] h-[100%] flex items-center justify-center relative z-10">
        <div className="h-[200px] w-[450px] lg:h-[400px] blur-3xl rounded-[50%] bg-indigo-600/20 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] animate-pulse"></div>
        <div className="p-[30px] text-center border-r-[50%] relative animate-fade-in-slow">
          <p className="text-[35px] lg:text-[55px]">👋</p>
          <h4 className="text-text-secondary text-[22px] lg:text-[28px] font-medium">
            Welcome to
          </h4>
          <BrandedLogo className=" w-[200px] lg:w-[300px] mt-2 h-[auto] object-cover" alt="" />
        </div>
      </div>
      {/* AUTH PAGE LOGO */}

      {/* LOGIN AND RESET FORM */}

      <div className="w-[100%] lg:w-[55%] h-full flex items-center justify-center">
        <div
          className={`w-[90%] lg:w-[55%] max-w-[430px] h-[480px] relative [perspective:1000px] `}
        >
          <div
            className={`h-full w-full relative transition-all duration-500 [transform-style:preserve-3d] [transform:rotateY(0deg)]`}
          >
            <MicrosoftLogin />
          </div>
        </div>
      </div>

      {/* LOGIN AND RESET FORM */}
    </div>
  );
};

export default Auth;
